module.exports = __webpack_public_path__ + "static/media/icon400t.b3c89351.png";